import type { SxProps } from "@mui/material";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

interface LoadingSpinnerProps {
  sx?: SxProps;
}
const LoadingSpinner = ({ sx = {} }: LoadingSpinnerProps) => {
  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        ...sx,
      }}
    >
      <CircularProgress sx={{ color: "primary.darker" }} />
    </Box>
  );
};

export default LoadingSpinner;
